"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.t = void 0;
const i18next_1 = __importDefault(require("i18next"));
const react_i18next_1 = require("react-i18next");
const i18next_browser_languagedetector_1 = __importDefault(require("i18next-browser-languagedetector"));
const en = __importStar(require("./locales/en"));
const fr = __importStar(require("./locales/fr"));
const de = __importStar(require("./locales/de"));
const pt = __importStar(require("./locales/pt"));
const es = __importStar(require("./locales/es"));
i18next_1.default
    // detect user language
    // learn more: https://github.com/i18next/i18next-browser-languageDetector
    .use(i18next_browser_languagedetector_1.default)
    // pass the i18n instance to react-i18next.
    .use(react_i18next_1.initReactI18next)
    // init i18next
    // for all options read: https://www.i18next.com/overview/configuration-options
    .init({
    debug: true,
    fallbackLng: 'en',
    // lng: 'en', // default language
    interpolation: {
        escapeValue: false, // not needed for react as it escapes by default
    },
    resources: { en, fr, de, pt, es },
    supportedLngs: ['en', 'fr', 'de', 'pt', 'es'], // array of allowed languages (to exclude local codes)
});
exports.t = i18next_1.default.t;
exports.default = i18next_1.default;
